import { useState } from "react";
import SEO from "@/components/SEO";
import { PageHero, Section } from "@/components/sections";
import { MFCalculator, RetirementCalculator, BondCalculator } from "@/components/Calculators";
import { Reveal } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";

const tools = [
  { id: "mf", name: "MF Calculator", sub: "SIP · Lumpsum · SIP+SWP · SWP" },
  { id: "retirement", name: "Retirement Planner", sub: "Corpus & required SIP" },
  { id: "bond", name: "Bond vs FD", sub: "Yield & approx. YTM" },
];

export default function Calculators() {
  const [active, setActive] = useState("mf");
  return (
    <div>
      <SEO path="/calculators" title="Financial Calculators" description="Illustrative SIP, lumpsum, SWP, retirement and bond-vs-FD calculators from Rao Investment Solutions. Estimates only, subject to market risk." />
      <PageHero
        label="Tools"
        title="Illustrative calculators"
        intro="Model different scenarios instantly. Every output is an illustrative estimate based on your assumptions — never a guarantee."
        breadcrumbs={[{ name: "Home", to: "/" }, { name: "Resources" }, { name: "Calculators" }]}
      />

      <Section className="!pt-0">
        <div className="flex flex-wrap gap-3 mb-10">
          {tools.map((t) => (
            <button
              key={t.id}
              onClick={() => setActive(t.id)}
              data-testid={`calc-tab-${t.id}`}
              className={`px-6 py-4 text-left transition-colors border ${
                active === t.id ? "bg-navy text-white border-navy" : "bg-white text-navy border-navy/15 hover:border-navy"
              }`}
            >
              <div className="font-serif text-lg">{t.name}</div>
              <div className={`font-data text-xs mt-1 ${active === t.id ? "text-white/60" : "text-slate"}`}>{t.sub}</div>
            </button>
          ))}
        </div>

        <Reveal key={active}>
          {active === "mf" && <MFCalculator />}
          {active === "retirement" && <RetirementCalculator />}
          {active === "bond" && <BondCalculator />}
        </Reveal>
      </Section>

      <Section dark>
        <div className="grid lg:grid-cols-2 gap-14 items-start">
          <div>
            <span className="font-sans text-xs uppercase tracking-[0.24em] text-orange">Turn numbers into a plan</span>
            <h2 className="mt-4 font-serif text-3xl md:text-4xl text-white tracking-tight">Like what you see? Let's make it real.</h2>
            <p className="mt-5 font-sans text-white/70 text-lg">Calculators show the shape of a plan. We'll help you build the actual one — suited to your goals, taxes and risk.</p>
          </div>
          <div className="bg-white/5 border border-white/10 p-8 md:p-10">
            <LeadForm dark calculator={active} title="Discuss my numbers" subtitle="Share your details and we'll walk through a plan based on scenarios like these." />
          </div>
        </div>
      </Section>
    </div>
  );
}
